module.exports = __webpack_public_path__ + "img/join-member-en.bb058cb0.png";